const featureItems = [
  { title: '即点即播', desc: '无需注册登录，点击即可开始观影，零门槛畅享海量影视资源', icon: 'ri-flashlight-line', color: 'from-accent-500 to-accent-600' },
  { title: '超清画质', desc: '全线支持1080P高清，自适应码率确保流畅不卡顿', icon: 'ri-4k-line', color: 'from-primary-500 to-primary-600' },
  { title: '海量片源', desc: '超过20000部影视作品，覆盖全品类满足各类观影偏好', icon: 'ri-database-2-line', color: 'from-accent-500 to-accent-600' },
  { title: '每日更新', desc: '编辑团队实时追踪，热播剧集和院线新片及时上线', icon: 'ri-calendar-check-line', color: 'from-primary-500 to-primary-600' },
  { title: '安全纯净', desc: 'HTTPS加密传输，无恶意广告弹窗，纯净观影体验', icon: 'ri-shield-check-line', color: 'from-accent-500 to-accent-600' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">为什么选择我们</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">特色优势 · 观影首选</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">五大核心特色为你的观影体验保驾护航</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {featureItems.map((item, i) => (
            <div key={i} className="group text-center p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br ${item.color} flex items-center justify-center shadow-lg`}>
                <i className={`${item.icon} text-xl md:text-2xl text-background-50`}></i>
              </div>
              <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}